import React, { useCallback, useState } from "react";
import EmbedFormAlertModal from "./EmbedFormAlertModal";
import EmbedFormConfirmModal from "./EmbedFormConfirmModal";
import { EmbedFormBtn } from "./embedFormButtons";

/**
 * Imperative confirm/alert dialogs using Bootstrap modals (embed-forms only).
 * Render `dialogNodes` once near the root of the page component.
 */
export function useEmbedFormDialogs() {
    const [confirmState, setConfirmState] = useState(null);
    const [alertState, setAlertState] = useState(null);

    const hideConfirm = useCallback(() => {
        setConfirmState(null);
    }, []);

    const hideAlert = useCallback(() => {
        setAlertState((current) => {
            current?.onClose?.();
            return null;
        });
    }, []);

    const confirmDialog = useCallback((options) => {
        setConfirmState(options);
    }, []);

    const alertDialog = useCallback((options) => {
        setAlertState(options);
    }, []);

    const dialogNodes = (
        <>
            <EmbedFormConfirmModal
                show={confirmState != null}
                onHide={() => {
                    confirmState?.onCancel?.();
                    hideConfirm();
                }}
                title={confirmState?.title}
                message={confirmState?.message}
                confirmLabel={confirmState?.confirmLabel ?? "Confirm"}
                cancelLabel={confirmState?.cancelLabel ?? "Cancel"}
                onConfirm={confirmState?.onConfirm}
                confirmVariant={
                    confirmState?.confirmVariant ?? EmbedFormBtn.danger
                }
                cancelVariant={
                    confirmState?.cancelVariant ?? EmbedFormBtn.neutral
                }
                backdrop={confirmState?.backdrop ?? true}
                keyboard={confirmState?.keyboard ?? true}
                closeButton={confirmState?.closeButton ?? true}
            />
            <EmbedFormAlertModal
                show={alertState != null}
                onHide={hideAlert}
                title={alertState?.title ?? "Notice"}
                message={alertState?.message}
                buttonLabel={alertState?.buttonLabel ?? "OK"}
            />
        </>
    );

    return { confirmDialog, alertDialog, dialogNodes };
}
